import { Component, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FileUploadComponent } from "@/app/components/shared/file-manager/file-upload/file-upload.component";
import { NewFilesComponent } from "@/app/components/shared/file-manager/new-files/new-files.component";
import { OldFilesComponent } from "@/app/components/shared/file-manager/old-files/old-files.component";

import { DragAndDropFileUploadComponent } from "@/app/components/shared/file-manager/drag-and-drop-file-upload/drag-and-drop-file-upload.component";

@Component({
  selector: 'app-file-manager',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    FileUploadComponent,
    NewFilesComponent,
    OldFilesComponent,

    DragAndDropFileUploadComponent,
  ],
  templateUrl: './file-manager.component.html',
  styleUrl: './file-manager.component.css'
})
export class FileManagerComponent {
  /**
   * NOTE: we are passing the old files and the control name as props
   * When a new file is added, we emit the new file with the control name
   * Similarly when a file is removed, we emit the file with the control name
   */
  @Input() IsDragNDrop: boolean = false;
  @Input() label: string = 'Attach Document';
  @Input() newFileControlName: string = '';
  @Input() oldFiles: any[] = [];

  @Output() newFilesUpdatedEvent = new EventEmitter<{
    files: File[],
    controlName: string,
    isEmpty: boolean,
  }>();
  @Output() oldFilesDeletedEvent = new EventEmitter<object>();

  newFiles: File[] = [];

  // NOTE: We are sending the new files to app-new-files component as prop
  // Handle selection of new files
  onFilesSelected(files: File[]) {
    this.newFiles = [...this.newFiles, ...files];

    // send these new files data to parent component
    this.newFilesUpdatedEvent.emit({
      files: this.newFiles,
      controlName: this.newFileControlName,
      isEmpty: false,
    });
  }

  // Handle removal of new files
  onRemoveNewFile(file: File) {
    this.newFiles = this.newFiles.filter((f) => f !== file);
    // If new files are empty, we set the isEmpty flag to true
    let isNewFilesEmpty = false;
    if (this.newFiles.length === 0) {
      isNewFilesEmpty = true
    }
    
    this.newFilesUpdatedEvent.emit({
      files: this.newFiles,
      controlName: this.newFileControlName,
      isEmpty: isNewFilesEmpty,
    });
  }

  // Handle removal of old files
  onRemoveOldFile(file: any) {
    this.oldFilesDeletedEvent.emit({
      file: file,
      controlName: this.newFileControlName,
    });
  }

}
